import * as actionTypes from '../actionTypes'

import { saveFileFromResponse } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import levelGroupAxios from '../../../axios/levelGroup'
import reportAxios from '../../../axios/report'

export const fetchLevelGroupFilterAppraisal = filter => {
  return dispatch => {
    dispatch(fetchLevelGroupFilterAppraisalStart())
    levelGroupAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelGroupFilterAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelGroupFilterAppraisalFailed(error?.response?.data?.message))
      })
  }
}

export const fetchLevelGroupFilterAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_FILTER_APPRAISAL_START
  }
}

export const fetchLevelGroupFilterAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_FILTER_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchLevelGroupFilterAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_FILTER_APPRAISAL_FAILED,
    errorMessage
  }
}

export const reportAppraisalSummary = recordData => {
  return dispatch => {
    dispatch(reportAppraisalSummaryStart())

    reportAxios
      .post('/report_appraisal_summary', recordData, { responseType: 'blob' })
      .then(response => {
        // if (recordData.format === 'xls') {
        saveFileFromResponse(response)
        // }
        dispatch(
          enqueueSnackbar({
            message: 'Report Appraisal Summary Created',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(reportAppraisalSummarySuccess(response.data))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(reportAppraisalSummaryFailed())
      })
  }
}

export const reportAppraisalSummaryStart = () => {
  return {
    type: actionTypes.REPORT_APPRASAL_SUMMARY_START
  }
}

export const reportAppraisalSummarySuccess = data => {
  return {
    type: actionTypes.REPORT_APPRASAL_SUMMARY_SUCCESS,
    data
  }
}

export const reportAppraisalSummaryFailed = () => {
  return {
    type: actionTypes.REPORT_APPRASAL_SUMMARY_FAILED
  }
}

export const clearReportAppraisalSummary = () => {
  return {
    type: actionTypes.CLEAR_REPORT_APPRASAL_SUMMARY
  }
}
